<template>
    <v-container>
        <v-card class="pl-10 pr-10">
            <v-card-title class="pb-0">
                <b>Stock : รายการรับวัสดุสิ้นเปลือง</b>
                <v-spacer></v-spacer>
                <v-spacer></v-spacer>
                <v-spacer></v-spacer>
                <UserBranchDropdown :pageCode="pageCode" @onUserBranchChange='setCurrentBranch'></UserBranchDropdown>
            </v-card-title>
            <v-divider></v-divider>
            <v-card flat>
                 <v-container>
                    <v-form ref="form" lazy-validation>
            
                <v-row>
                <v-col cols="2"><DatePicker label="ตั้งแต่วันที่" @dateFormatted="setDateFrom" ></DatePicker></v-col>
                <v-col cols="2"><DatePicker label="ถึงวันที่" @dateFormatted="setDateTo" ></DatePicker></v-col>
                <v-col><v-text-field  v-model="receiveNo" @keyup.enter.native="search" label="เลขที่ใบรับวัสดุสิ้นเปลือง" placeholder=" " outlined></v-text-field></v-col>
                <v-col class="text-right">
                    <v-row>
                        <v-col >
                            <v-btn  class="ma-2" color="primary" small @click="search"><v-icon>search</v-icon> ค้นหา</v-btn>
                        </v-col>
                        <v-col >
                            <AddStockConsumable ref="stock" :branchCode="branchCode" @saved="search"></AddStockConsumable>
                        </v-col>
                        <v-spacer></v-spacer>
                    </v-row>
                </v-col>
                
            </v-row>            
            </v-form></v-container>
                
    <v-data-table
        :headers="headers"
        :items="items"
        class="pt-5"
        fixed-header
        height="350"
    >
        <template v-slot:top>
                <v-dialog v-model="viewDialog" persistent>
                    <ViewStockConsumable :mainData="mainData" :itemSummary="itemSummary"  @close="close"></ViewStockConsumable>
                </v-dialog>
                    
            </template>

            <template v-slot:item.action="{ item }">
                <v-icon
                    v-if="item.status == 'draft'"
                    small
                    @click="editData(item)"
                >
                    edit
                </v-icon>
                <v-icon
                    v-else
                    small
                    @click="viewData(item)"
                >
                    search
                </v-icon>
                <v-icon
                    small
                    @click="deleteData(item)"
                >
                    delete
                </v-icon>
            </template>
    </v-data-table>

            </v-card>
        </v-card>
    </v-container>
</template>

<script>
import UserBranchDropdown from '@/components/Shared/UserBranchDropdown'
import DatePicker from '@/components/Shared/DatePicker'
import {getStockConsumable, listStockConsumableByReceiveNo, deleteStockConsumable} from '@/api/stock/stock-consumable-api.js'
import ViewStockConsumable from './ViewStockConsumable'
import numeral from 'numeral'
import AddStockConsumable from './AddStockConsumable'

export default {
    name: 'SearchReceive',
    components: {
        DatePicker,
        UserBranchDropdown,
        ViewStockConsumable,
        AddStockConsumable
    },
    watch: {
        branchCode(val) {
            if (val) {
                this.search();
            }
        }
    },
    props: ["pageCode"],
    data: () => ({
        branchCode: '',
        dialog: false,
        viewDialog: false,
        valid: false,
        headers: [
            {text: "เลขที่ใบรับวัสดุสิ้นเปลือง", value: "receiveNo"},
            {text: "วันที่รับวัสดุสิ้นเปลือง", value: "receiveDate", width: "160px"},
            {text: "ยอดรวม", value: "netAmountDisplay", align: "right"},
            {text: "ผู้รับ", value: "createBy"},
            {text: "สถานะ", value: "status"},
            {text: 'Actions', value: 'action', sortable: false}
        ],
        items: [

        ],
        dateFrom: null,
        dateTo: null,
        receiveNo: '',
        receiver: '',
        rules: {
            required: value => !!value || 'Required.'
        },
        itemId: '',
        mainData: {
            branchCode: '',
            receiveNo: '',
            docDate: '',
            receiveDate: '',
            distributor: '',
            percentDiscount: 0,
            details: []
        },
         summaryDefault: {
            amount: 0,
            discount: 0,
            net: 0,
            amountDisplay: 0,
            discountDisplay: 0,
            netDisplay: 0
        },
         summary: {
            sum: {
                sumType: 'รวม',
                amount: 0,
                discount: 0,
                net: 0,
                amountDisplay: 0,
                discountDisplay: 0,
                netDisplay: 0
            },
            vat: {
                sumType: 'ภาษี 7%',
                amount: 0,
                discount: 0,
                net: 0,
                amountDisplay: 0,
                discountDisplay: 0,
                netDisplay: 0
            },
            total: {
                sumType: 'รวมทั้งสิ้น',
                amount: 0,
                discount: 0,
                net: 0,
                amountDisplay: 0,
                discountDisplay: 0,
                netDisplay: 0
            }
        },
        itemSummary: [],
         detail: {
                consumableCode: '',
                consumableName: '',
                warehouse: '',
                unitPrice: 0,
                qty: 1,
                amount: 0,
                netAmount: 0,
                percentDiscount: 0,
                discount: 0,
                remark: '',
        }
    }),
    methods: {
        addClick() {
            this.dialog = true;
        },
        setCurrentBranch(branchCode) {
            this.branchCode = branchCode;
        },
        setDateFrom(val) {
            this.dateFrom = val;
        },
        setDateTo(val) {
            this.dateTo = val;
        },
        search() {
            this.dateFrom = this.dateFrom.replace("/", "-").replace("/", "-");
            this.dateTo = this.dateTo.replace("/", "-").replace("/", "-");
            listStockConsumableByReceiveNo(this.branchCode, this.dateFrom, this.dateTo, this.receiveNo).then(rs => {
                this.items = rs;
                if (this.items) {
                    this.items.forEach((e) => {
                        e.netAmountDisplay = numeral(e.netAmount).format('0,0.00');
                    });
                }
            })
        },
        deleteData(item) {
            if (confirm("ต้องการลบรายการ ?")) {
                deleteStockConsumable(item.stockConsumableId).then(() => {
                    let index = this.items.indexOf(item);
                    this.items.splice(index, 1);
                });
            }
            
        },
        viewData(item) {
            this.itemId = item.stockConsumableId;
            this.itemSummary =  Object.assign([], []);
            this.mainData.details = [];
            this.$loading(true);
            getStockConsumable(this.itemId).then(rs => {
                this.mainData = rs;
                if (!this.mainData.details) return;

                this.resetSummary();
                this.mainData.details.forEach(detail => {
                    detail.amount = parseFloat(detail.qty) * parseFloat(detail.price);
                    this.setDetailDisplay(detail);
                    this.calculateSummary(detail);
                });

                this.itemSummary.push(this.summary.sum);
                this.itemSummary.push(this.summary.vat);
                this.itemSummary.push(this.summary.total);
                this.$loading(false);
            }).catch(() => {
                this.$loading(false);
            });
            this.viewDialog = true;
        },
        editData(item) {
            this.itemId = item.stockConsumableId;
            this.itemSummary =  Object.assign([], []);
            this.mainData.details = [];
            this.resetSummary();
            this.$loading(true);
            getStockConsumable(this.itemId).then(rs => {
                this.mainData = rs;
                if (!this.mainData.details) return;

                
                this.mainData.details.forEach(detail => {
                    detail.amount = parseFloat(detail.qty) * parseFloat(detail.price);
                    this.setDetailDisplay(detail);
                    this.calculateSummary(detail);
                });

                this.itemSummary.push(this.summary.sum);
                this.itemSummary.push(this.summary.vat);
                this.itemSummary.push(this.summary.total);
                this.$loading(false);
                this.$refs.stock.show(this.itemSummary, this.mainData);
            }).catch(() => {
                this.$loading(false);
            });
            
        },
        setDetailDisplay(detail) {
            detail.unitPriceDisplay = numeral(detail.unitPrice).format('0,0.00');
            detail.priceDisplay = numeral(detail.price).format('0,0.00');
            detail.amountDisplay = numeral(detail.amount).format('0,0.00');
            detail.discountDisplay = numeral(detail.discount).format('0,0.00');
            detail.netAmountDisplay = numeral(detail.netAmount).format('0,0.00');
        },
        calculateSummary(detail) {
            this.summary.sum.amount += detail.amount;
            this.summary.sum.discount += detail.discount;
            this.summary.sum.net += detail.netAmount;

            this.summary.vat.amount = (this.summary.sum.amount * 7) / 100;
            this.summary.vat.discount = (this.summary.sum.discount * 7) / 100;
            this.summary.vat.net = (this.summary.sum.net * 7) / 100;

            this.summary.total.amount = this.summary.sum.amount + this.summary.vat.amount;
            this.summary.total.discount = this.summary.sum.discount + this.summary.vat.discount;
            this.summary.total.net = this.summary.sum.net + this.summary.vat.net;
            
            this.setSummaryDisplay(this.summary.sum);
            this.setSummaryDisplay(this.summary.vat);
            this.setSummaryDisplay(this.summary.total);
        },
         setSummaryDisplay(summary) {
            summary.amountDisplay = numeral(summary.amount).format('0,0.00');
            summary.discountDisplay = numeral(summary.discount).format('0,0.00');
            summary.netDisplay = numeral(summary.net).format('0,0.00');
        },
        getSummaryDefault(type) {
            this.summaryDefault.sumType = type;
            return this.summaryDefault;
        },
        resetSummary() {
            this.summary.sum = {sumType: 'รวม'};
            this.summary.sum = Object.assign(this.summary.sum, this.summaryDefault);
            this.summary.vat = {sumType: 'ภาษี 7%'};
            this.summary.vat = Object.assign(this.summary.vat, this.summaryDefault);
            this.summary.total = {sumType: 'รวมทั้งสิ้น'};
            this.summary.total = Object.assign(this.summary.total, this.summaryDefault);
        },
        close() {
            this.resetSummary();
            this.viewDialog = false;
            this.search();
        }
    }
}
</script>